import { WaybillIdView } from '../../../models';

export class ShipmentWaybillItemSetIdentifier {
  public static readonly type = '[ShipmentWaybillItem] Set Shipment Waybill Identifier';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillCustomsDocumentsCountLoad {
  public static readonly type = '[ShipmentWayBillItem] Customs Documents Count Load';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillItemNotificationListCountLoad {
  public static readonly type = '[ShipmentWaybillItem] Notification List Load';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillItemSetInitial {
  public static readonly type = '[ShipmentWaybillItem] Set Initial State';
}

export class ShipmenWaybillDemurrageAndDetentionTabAvailability {
  public static readonly type = '[ShipmentWaybillItem] Get Shipment Waybill D&D Tab Availability';
  constructor(public payload: string) {}
}
